import React, { FC } from 'react';
import styles from './folders_dropdown_choose_container.module.scss';

export const FoldersDropdownChooseContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
